/**
 * Finance configuration constants.
 *
 * Fees that come from the API at runtime should use these values only as
 * safe fallbacks when the API response is unavailable.  All polling and UX
 * timing constants live here so they are easy to locate and adjust.
 */

// --- Transfer fees (fallback defaults — overridden by /fees API response) ---
/** Fixed transfer fee in BRL charged per withdrawal. */
export const DEFAULT_TRANSFER_FEE_FIXED = 5;

/** Early-withdrawal fee as a decimal fraction (2 %). */
export const DEFAULT_EARLY_WITHDRAWAL_FEE_PERCENT = 0.02;

// --- Payout timing ---
/** Days after card payment until funds are available for withdrawal. */
export const CARD_PAYOUT_DELAY_DAYS = 2;

// --- Polling ---
/** Interval between background data-refresh polls, in milliseconds. */
export const FINANCE_POLL_INTERVAL_MS = 15_000;

// --- Support ---
/** Mailto link shown to organizers when a withdrawal fails permanently. */
export const SUPPORT_MAILTO = 'mailto:suporte@presentei.com';
